module.exports = __webpack_public_path__ + "img/hs.a07a5fdf.png";